import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export function LegalLayout({ title, testid, intro, children }) {
  return (
    <div data-testid={testid} className="pt-28 pb-20 min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-jamaica-green mb-3">Turahtid Clothing · Legal</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none">{title}</h1>
        <div className="h-1 w-16 bg-jamaica-gold mt-5 mb-8" />
        {intro && <p className="text-zinc-300 leading-relaxed text-base mb-10">{intro}</p>}
        <div className="space-y-8">{children}</div>

        <div className="mt-14 border-t border-white/10 pt-6">
          <p className="font-mono text-[11px] uppercase tracking-widest text-zinc-500 mb-3">Questions? Reach us</p>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-jamaica-gold" /> May Pen, Clarendon, Jamaica</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-jamaica-gold" /> <a href="mailto:talenteduniquerebel@gmail.com" className="hover:text-jamaica-gold">talenteduniquerebel@gmail.com</a></li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-jamaica-gold" /> <a href="tel:+18763539081" className="hover:text-jamaica-gold">+1 (876) 353-9081</a></li>
          </ul>
          <Link to="/shop" className="inline-block mt-8 font-mono text-xs uppercase tracking-widest text-jamaica-gold hover:text-yellow-300">← Back to Shop</Link>
        </div>
      </div>
    </div>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section>
      <h2 className="font-heading font-bold uppercase text-base md:text-lg text-white mb-2">{heading}</h2>
      <p className="text-zinc-300 leading-relaxed text-sm md:text-base">{children}</p>
    </section>
  );
}
